import { Link } from "react-router-dom";
import type { WymhSiteConfig } from "@/mocks/wymh-config";
import { WYMH_NAV, wymhJumpToSection } from "@/components/feature/wymh-site-header";

interface WymhSiteFooterProps {
  config: WymhSiteConfig;
}

export default function WymhSiteFooter({ config }: WymhSiteFooterProps) {
  return (
    <footer
      id="wymh-contact"
      className="wymh-anchor w-full text-background-50"
      style={{
        backgroundImage: "linear-gradient(135deg, #78133a 0%, #8f1240 45%, #7f2510 100%)",
      }}
    >
      <div className="w-full px-4 md:px-8 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 w-full">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-12 h-12 rounded-2xl overflow-hidden flex items-center justify-center bg-foreground-950 shrink-0">
                <img
                  src="/images/wymh-app-icon.png"
                  alt="五一漫画App图标"
                  title="五一漫画官方图标"
                  className="w-full h-full object-top"
                />
              </span>
              <span className="wymh-heading text-2xl">五一漫画</span>
            </div>
            <p className="text-sm leading-7 text-background-100/85 max-w-sm">
              正版在线漫画阅读平台，都市、恋爱、玄幻、悬疑等六大品类随手追更，四端同步、离线缓存、无广告纯净阅读。
            </p>
          </div>

          <div className="md:pl-4">
            <h4 className="text-sm font-bold tracking-widest text-accent-200 mb-5">站内导航</h4>
            <ul className="flex flex-col gap-3">
              {WYMH_NAV.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      wymhJumpToSection(item.id);
                    }}
                    className="text-sm text-background-100/85 hover:text-accent-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/download" className="text-sm text-background-100/85 hover:text-accent-200 cursor-pointer">
                  下载客户端
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-widest text-accent-200 mb-5">联系我们</h4>
            <div className="rounded-2xl bg-foreground-950/30 border border-background-50/15 p-5">
              <p className="text-xs text-background-100/70 mb-2">商务合作 / 问题反馈邮箱</p>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300 w-5 h-5 flex items-center justify-center"></i>
                <span className="text-base font-bold text-background-50 break-all">{config.contactEmail}</span>
              </div>
              <p className="text-xs text-background-100/60 mt-3 leading-6">
                官方网址 {config.domain}，软件问题请附上设备型号与系统版本，我们会尽快回复。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/70">
            © 2026 {config.domain} · 保留权利
          </p>
          <p className="text-xs text-background-100/70">
            漫画内容版权归各自作者所有 · 请勿用于商业传播
          </p>
        </div>
      </div>
    </footer>
  );
}